/*interface AudioPlayerDetailCallbacks {
    created?: (instance: AudioPlayerDetail) => any,
    played?: (instance: AudioPlayerDetail) => any,
}*/

import ProgressRange from "./progress-range";

class Player {

    protected playlist = [];
    protected currentTrack = [];
    protected currentTrackId = null;
    protected timelineRange;
    // protected timelineRangeMobile;
    protected volumeRange;
    protected audio;
    protected tracks;

    protected player;
    protected playerImageContainer;
    protected playerTitle;
    protected playerDesc;
    protected playerImage;

    protected playButton;
    protected prevButton;
    protected nextButton;
    protected closeButton;

    constructor() {

        this.player = document.querySelector('.podcasts__player-container');
        this.playerImageContainer = document.querySelector('.podcasts__player-info-image-wrapper');
        this.playerImage = document.createElement('img');
        this.playerImageContainer.appendChild(this.playerImage)
        this.playerTitle = document.querySelector('.podcasts__player-info-title');
        this.playerDesc = document.querySelector('.podcasts__player-info-desc');

        /* Buttons */
        this.playButton = document.querySelector('.js-podcasts-play-btn');
        this.prevButton = document.querySelector('.podcasts__player-controls-btn.btn-prev')
        this.nextButton = document.querySelector('.podcasts__player-controls-btn.btn-next')
        this.closeButton = document.querySelectorAll('.podcasts__player-close')


        Array.from(this.closeButton).forEach((item: HTMLElement) => {
            item.addEventListener('click', () => {
                this.currentTrackId = null

                if (this.audio)
                    this.audio.src = '';

                this.updatePlayButtonIcon()
                this.unbindEvents();

                this.player.classList.remove('playing')
            })
        })

        //todo JS
        $(document).on('click', '.podcast-list-player .podcasts-play-btn, .js-play-audio, .js-start-playlist', this.init.bind(this))

        this.timelineRange = new ProgressRange('.podcasts__player-progress-bar.desktop .progress-range', {
            onMouseUp: (percent) => this.setCurrentTime(percent)
        });

        /*   this.timelineRangeMobile = new ProgressRange('.podcasts__player-progress-bar.mobile .progress-range', {
               onMouseUp: (percent) => this.setCurrentTime(percent)
           });
   */
        this.volumeRange = new ProgressRange('.podcasts__player-props-volume-range .progress-range', {
            onMouseUp: (percent) => {
                percent = percent > 100 ? 100 : (percent < 0 ? 0 : percent)
                this.audio.volume = percent / 100;
            }
        });
    }

    public init(event) {
        if (typeof event.currentTarget.dataset.trackId !== 'undefined')
            this.initTrack(event.currentTarget.dataset.trackId);
    }

    public initPlaylist() {
        this.playlist = [];
        Array.from(document.querySelectorAll('.podcasts--best--item, .podcasts__last-item, .podcast-playlist--item')).forEach((item: HTMLElement) => {
            const data = {
                'img': item.querySelector('img') ? item.querySelector('img').src : (item.querySelector('.img-src') ? item.querySelector('.img-src').getAttribute('href') : ''),
                'title': (item.querySelector('.podcasts--best__name') || item.querySelector('.podcasts__last-item-title') || item.querySelector('.podcast-playlist--title')).innerHTML,
                'desc': item.querySelector('.podcasts__last-item-desc div:first-child') ? item.querySelector('.podcasts__last-item-desc div:first-child').innerHTML
                    : (item.querySelector('.podcast-playlist--desc') ? item.querySelector('.podcast-playlist--desc').innerHTML :  ''),
                'audio': item.querySelector('.btn-download').getAttribute('href'),
            };
            this.playlist.push(data)

            console.log(this.playlist)
        })
    }

    public initTrack(trackId) {

        if (!this.player.classList.contains('playing')) {
            this.player.classList.add('playing')
        }
        this.timelineRange.setProgress(0);

        if (this.currentTrackId !== null && this.currentTrackId === trackId) {
            this.playPause()
            return;
        }
        this.currentTrackId = trackId

        if (this.audio)
            this.audio.src = '';


        this.unbindEvents();

        this.initPlaylist();

        this.currentTrack = this.playlist[this.currentTrackId];

        this.audio = new Audio(this.currentTrack['audio']);

        this.bindEvents();

        if (this.audio.paused) {
            this.audio.play();
        }

        this.updatePlayButtonIcon()

        this.playerTitle.innerHTML = this.currentTrack['title'];
        // this.playerDesc.innerHTML = this.currentTrack['desc'];
        this.playerImage.src = this.currentTrack['img'];
    }

    public changeTrack = (e) => {
        let trackId = null;
        if (this.currentTrackId !== null && this.playlist.length > 0) {

            let direction = e.currentTarget.classList.contains('btn-prev') ? -1 : 1;
            trackId = +this.currentTrackId + direction;

            if (trackId < 0) {
                trackId = (this.playlist.length - 1)
            } else if (trackId == this.playlist.length) {
                trackId = 0
            }

            this.initTrack(trackId);
        }

    }

    protected unbindEvents() {
        this.prevButton.removeEventListener('click', this.changeTrack)
        this.nextButton.removeEventListener('click', this.changeTrack)
        this.playButton.removeEventListener("click", this.playPause)
    }

    protected bindEvents() {

        this.prevButton.addEventListener('click', this.changeTrack)
        this.nextButton.addEventListener('click', this.changeTrack)
        this.playButton.addEventListener("click", this.playPause)

        this.audio.addEventListener("loadeddata", () => {
            this.timelineRange.setProgress(0);
            // this.timelineRangeMobile.setProgress(0);
        });

        this.audio.addEventListener("timeupdate", () => {

            if (!this.timelineRange.mouseDownOnSlider /*&& !this.timelineRangeMobile.mouseDownOnSlider*/) {
                this.timelineRange.setProgress(this.audio.currentTime, this.audio.duration);
                // this.timelineRangeMobile.setProgress(this.audio.currentTime, this.audio.duration);

                const timeContainer = document.querySelectorAll('.podcasts__player-props-time.current');
                //const durationContainer = document.querySelectorAll('.podcasts__player-props-time.duration');

                let currentTime = this.audio.currentTime | 0;
                // let duration = this.audio.duration | 0;

                //let minutesDuration = Math.floor(duration / 60);
                //let secondsDuration = (duration - minutesDuration * 60);
                //let dur = ("0" + minutesDuration).substr(-2) + ":" +  + ("0" + secondsDuration).substr(-2);


                let minutes = Math.floor(currentTime / 60);
                let seconds = (currentTime - minutes * 60);
                let cur = ("0" + minutes).substr(-2) + ":" + ("0" + seconds).substr(-2);

                //Array.from(durationContainer).forEach(item => {
                //    item.innerHTML = dur
                //})

                Array.from(timeContainer).forEach(item => {
                    item.innerHTML = cur
                })
            }
        });

        /*audio.addEventListener("ended", () => {
            playButton.textContent = "▶️";
        });*/

    }

    public playPause = () => {
        this.audio.paused ? this.audio.play() : this.audio.pause();
        this.updatePlayButtonIcon()
    }

    public setCurrentTime(percent) {
        const pct = percent / 100;
        this.audio.currentTime = (this.audio.duration || 0) * pct;
    }

    protected updatePlayButtonIcon() {
        Array.from(document.querySelectorAll('.podcasts--best--item, .podcasts__last-item, .podcast-playlist--item')).forEach((item: HTMLElement) => {
            item.classList.remove('_played')
        })

        if (this.currentTrackId !== null) {
            const item = document.querySelector(`.podcasts--best--item[data-track-id="${this.currentTrackId}"]`) ||
                document.querySelector(`.podcasts__last-item[data-track-id="${this.currentTrackId}"]`);

            const item2 = document.querySelector(`.podcast-playlist--item[data-track-id="${this.currentTrackId}"]`);

            if (item)
                item.classList.add('_played')

            if (item2) {

                item2.classList.add('_played')
            }
        }

        if (!this.audio.paused) {
            this.playButton.classList.add('audio-played');
        } else {
            this.playButton.classList.remove('audio-played');
        }
    }


}

export default Player;
